import { SERVER_URL } from './../config/contants';
import { HEADERS } from './../config/contants';
import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class FavoritosProvider {

  dados: any = [];
  pagina: number = 1;
  hasmore: boolean = false;
  contentHeader: Headers = new Headers(HEADERS);

  constructor(public http: Http) {
    
  }

  refresh() {
    this.pagina = 1;
    this.hasmore = false;
    this.dados = [];
  }

  setPage(page) {
    this.pagina = page;
  }

  checkHasmore() {
    return this.hasmore;
  }
  
  registrarFavorito(cliente_id, produto_id) {
    return new Promise((resolve, reject) => {
      this.http.post(SERVER_URL + 'favoritos/registrarFavorito', JSON.stringify({ cliente_id: cliente_id, produto_id:produto_id }), { headers: this.contentHeader })
        .map(res => res.json())
        .subscribe(
        data => {
          resolve(data)
        },
        err => {
          reject(err)
        }
        );
    });
  }

  removerFavorito(cliente_id, produto_id) {
    return new Promise((resolve, reject) => {
      this.http.post(SERVER_URL + 'favoritos/removerFavorito', JSON.stringify({ cliente_id: cliente_id, produto_id:produto_id }), { headers: this.contentHeader })
        .map(res => res.json())
        .subscribe(
        data => {
          resolve(data)
        },
        err => {
          reject(err)
        }
        );
    });
  }

  verificarFavorito(cliente_id, produto_id) {

    return new Promise((resolve, reject) => {
      this.http.post(SERVER_URL + 'favoritos/verificarFavorito', JSON.stringify({ cliente_id: cliente_id, produto_id:produto_id }), { headers: this.contentHeader })
        .map(res => res.json())
        .subscribe(
        data => {
          resolve(data.response)
        },
        err => {
          reject(err)
        }
        );
    });
  }

  favoritos(cliente_id) {
    return new Promise((resolve, reject) => {
      this.http.post(SERVER_URL + 'favoritos/favoritos', JSON.stringify({ cliente_id: cliente_id, pagina: this.pagina }), { headers: this.contentHeader })
        .map(res => res.json())
        .subscribe(
        data => {
          this.hasmore = data.hasmore;
          if (this.hasmore) {
            this.setPage(this.pagina + 1);
          }
          for (var item of data.produtos) {
            this.dados.push(item);
          }
          resolve(this.dados);
        },
        err => {
          reject(err)
        }
        );
    });
  }

}






// WEBPACK FOOTER //
// ./src/providers/favoritos.ts